import React from 'react';

import { ThemeProvider } from 'next-themes';

import './src/styles/global.css';
import 'prismjs/themes/prism-twilight.css';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <ThemeProvider attribute="class" defaultTheme="system">
    {element}
  </ThemeProvider>
);
